export default "__VITE_ASSET__Bt1JfMC3__"